const mutations = {
  /**
   * @param state
   * @param user
   * @constructor
   */
  SET_AXIOS_ERROR (state, error) {
    state.axios_error = error
  },
  DELETE_AXIOS_ERROR (state) {
    state.axios_error = {}
  },
  SET_WS_STATUS (state, status) {
    state.ws_status = status
  }
}
export default mutations



//////////////////
// WEBPACK FOOTER
// ./state/error/error.mutations.js
// module id = null
// module chunks = 